module.exports = __webpack_public_path__ + "assets/img/partners-background.3905ab53.jpg";